import { useEffect, useRef, useState } from "react";
import { EnviaDatosAServicio } from "../../Funciones/Funciones";
import useToken from "../login/useToken";
import classes from "./ProveedorEdita.module.css";
import Select from "react-select";
import { Slide, toast } from "react-toastify";

function EditaProveedor(props) {
  const ProvSelRef = useRef();
  const ProvRef = useRef();
  const observRef = useRef();
  const IDProvRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [ProvsLoaded, setProvsLoaded] = useState([]);
  const { token } = useToken();
  const idCasa = token.casaSel;
  const [recargar, setRecargar] = useState(false);

  useEffect(() => {
    if (idCasa > 0) {
      setIsLoading(true);
      setRecargar(false);
      fetch("https://www.copilco.net/inc/funciones.React.php", {
        method: "POST",
        body: JSON.stringify({
          accion: "cargaProveedores",
          IDCasa: idCasa,
        }),
        headers: {
          "content-type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          //console.log("data", data);
          var Provs = [];
          if (data.ERROR !== "SI") {
            for (const key in data) {
              const datos = {
                ...data[key],
              };
              if (key === "RProveedores") {
                Provs = Object.keys(datos).map((key) => datos[key]);
              }
            }
            //console.log(Provs);
            const ProvsT = Provs.map((prov) => {
              return {
                value: prov.IDProv,
                label: prov.Proveedor,
                observ: prov.Observaciones === null ? "" : prov.Observaciones,
              };
            });
            //console.log("ceCos", ceCos);
            //console.log("ProvsT", ProvsT);
            setProvsLoaded(ProvsT);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            console.log("ERROR", data.DESCERROR);
          }
        });
    } else {
      setIsLoading(false);
    }
  }, [idCasa, recargar]);

  const GuardaProv = async (ev) => {
    ev.preventDefault();
    if (IDProvRef.current.value === "") {
      props.setDialogoOK({
        texto: "por favor selecciona el proveedor a modificar",
        mostrandoError: true,
        recargar: false,
        cerrarVentana: "",
      });
      props.setMuestraDialogoOK(true);
    } else if (ProvRef.current.value === "") {
      props.setDialogoOK({
        texto: "por favor llena el nombre del Proveedor",
        mostrandoError: true,
        recargar: false,
        cerrarVentana: "",
      });
      props.setMuestraDialogoOK(true);
    } else {
      const ProvN = {
        IDProv: IDProvRef.current.value,
        IDCasa: idCasa,
        Proveedor: ProvRef.current.value,
        Observaciones: observRef.current.value,
      };
      console.log("ProvN", ProvN);
      const envio = await EnviaDatosAServicio(ProvN, "editaProveedor");
      if (envio.ERROR === "") {
        toast("Guardado OK", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          transition: Slide,
        });
        setRecargar(true);
      } else {
        props.setDialogoOK({
          texto: "Error al guardar: " + envio.DESCERROR,
          mostrandoError: true,
          recargar: false,
          cerrarVentana: "",
        });
        props.setMuestraDialogoOK(true);
        //alert("Error al guardar: " + envio.DESCERROR);
      }
    }
  };

  function cancelaNuevo(ev) {
    ev.preventDefault();
    props.setMuestraEditaProv(false);
  }

  function cambioProv(selectedOption) {
    IDProvRef.current.value = selectedOption.value;
    ProvRef.current.value = selectedOption.label;
    observRef.current.value = selectedOption.observ;
  }

  /**************************************************************************************/
  /************************************ render ******************************************/
  /**************************************************************************************/
  //console.log(ProvsLoaded);
  if (isLoading) {
    //console.log("cargando");
    return (
      <section className={classes.modal}>
        <h1>Loading...</h1>
      </section>
    );
  }
  return (
    <section className={classes.modal}>
      <div className={classes.divBotones}>
        {props.nivel === 1 ? (
          <button className={classes.botones} onClick={(ev) => GuardaProv(ev)}>
            <i className="fas fa-save"></i>
          </button>
        ) : null}
        <button className={classes.botones} onClick={cancelaNuevo}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      {props.nivel === 1 ? <h1>Cambia Proveedor</h1> : <h1>Ver Proveedores</h1>}
      <div className={classes.contSelect}>
        {props.nivel === 1 ? (
          <label className={classes.labelP}>Modificar:</label>
        ) : (
          <label className={classes.labelP}>Proveedores:</label>
        )}
        <Select
          ref={ProvSelRef}
          className={classes.textareaNE1}
          options={ProvsLoaded}
          onChange={cambioProv}
        />
      </div>
      <hr className={classes.linea}></hr>
      <div className={classes.contRenglon}>
        <label className={classes.labelP}>IDProv:</label>
        <input
          required
          readOnly
          type="text"
          ref={IDProvRef}
          className={classes.textareaNE}
        ></input>
      </div>
      <div className={classes.contRenglon}>
        <label className={classes.labelP}>Proveedor:</label>
        <input
          required
          type="text"
          ref={ProvRef}
          placeholder="Nombre Proveedor"
          className={classes.textareaNE}
        ></input>
      </div>
      <div className={classes.contRenglon}>
        <label className={classes.labelP}>Observaciones:</label>
        <input
          required
          type="text"
          ref={observRef}
          placeholder="Algun comentario?"
          className={classes.textareaNE}
        ></input>
      </div>
    </section>
  );
}

export default EditaProveedor;
